define('TescoMobile_Checkout/js/action/validate-cart-items',['jquery', 'Magento_Checkout/js/model/quote', '../model/choice-resource-url-manager', 'mage/storage'], function ($, quote, urlManager, storage) {
  'use strict';

  return function (deferred) {
    deferred = deferred || $.Deferred();
    var serviceUrl = urlManager.getUrlForValidateCartItems(quote);
    return storage.post(serviceUrl).done(function (response) {
      deferred.resolve(response);
    }).fail(function (rsponse) {
      deferred.reject();
    });
  };
});

